import { ReportsInsightsData } from '../../../application/domain/entities/ReportsInsightsData';
import { ReportsInsightsDto } from '../dto/ReportsInsightsDto';
import { ReportCategoryEnum, DelayCategoryEnum } from '../../../../../shared/application/domain/enums/ReportStatus';

function toReportCategoryEnum(value: string): ReportCategoryEnum {
  return value as ReportCategoryEnum;
}

function toDelayCategoryEnum(value: string): DelayCategoryEnum {
  return value as DelayCategoryEnum;
}

export function mapReportsInsightsDtoToEntity(
  dto: ReportsInsightsDto,
): ReportsInsightsData {
  return {
    i9Processed: (dto.i9Processed ?? []).map((item) => ({
      month: item.month,
      year: item.year,
      count: item.count,
    })),
    statusDistribution: (dto.statusDistribution ?? []).map((item) => ({
      status: toReportCategoryEnum(item.status),
      count: item.count,
    })),
    delayedStats: (dto.delayedStats ?? []).map((item) => ({
      category: toDelayCategoryEnum(item.category),
      count: item.count,
      statusBreakdown: (item.statusBreakdown ?? []).map((sb) => ({
        status: toReportCategoryEnum(sb.status),
        count: sb.count,
      })),
      users: (item.users ?? []).map((user) => ({
        userId: user.userId,
        userName: user.userName,
        email: user.email,
        status: toReportCategoryEnum(user.status),
      })),
    })),
  };
}
